"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rdf_string_1 = require("rdf-string");

var sparqlee_1 = require("sparqlee");

var actor_abstract_bindings_hash_1 = require("@comunica/actor-abstract-bindings-hash");

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A state manager for the groups constructed by consuming the bindings-stream.
 */


var GroupsState =
/*#__PURE__*/
function () {
  function GroupsState(pattern, sparqleeConfig) {
    _classCallCheck(this, GroupsState);

    this.pattern = pattern;
    this.sparqleeConfig = sparqleeConfig;
    this.groups = new Map();
    this.groupVariables = new Set(this.pattern.variables.map(rdf_string_1.termToString));
    this.distinctHashes = pattern.aggregates.some(function (_ref) {
      var distinct = _ref.distinct;
      return distinct;
    }) ? new Map() : null;
  }
  /**
   * - Consumes a stream binding
   * - Find the corresponding group and create one if need be
   * - Feeds the binding to the group's aggregators
   *
   * @param {Bindings} bindings - The Bindings to consume
   */


  _createClass(GroupsState, [{
    key: "consumeBindings",
    value: function consumeBindings(bindings) {
      var _this = this;

      // Select the bindings on which we group
      var grouper = bindings.filter(function (_, variable) {
        return _this.groupVariables.has(variable);
      }).toMap();
      var groupHash = this.hashBindings(grouper); // First member of group -> create new group

      if (!this.groups.has(groupHash)) {
        // Initialize state for all aggregators for new group
        var aggregators = {};

        for (var i in this.pattern.aggregates) {
          var aggregate = this.pattern.aggregates[i];
          var key = rdf_string_1.termToString(aggregate.variable);
          aggregators[key] = new sparqlee_1.AggregateEvaluator(aggregate, this.sparqleeConfig);
          aggregators[key].put(bindings);
        }

        var group = {
          aggregators: aggregators,
          bindings: grouper
        };
        this.groups.set(groupHash, group);

        if (this.distinctHashes) {
          var bindingsHash = this.hashBindings(bindings);
          this.distinctHashes.set(groupHash, new Set([bindingsHash]));
        }
      } else {
        // Group already exists
        // Update all the aggregators with the input binding
        var _group = this.groups.get(groupHash);

        for (var _i in this.pattern.aggregates) {
          var _aggregate = this.pattern.aggregates[_i]; // If distinct, check first wether we have inserted these values already

          if (_aggregate.distinct) {
            var hash = this.hashBindings(bindings);

            if (this.distinctHashes.get(groupHash).has(hash)) {
              continue;
            } else {
              this.distinctHashes.get(groupHash).add(hash);
            }
          }

          var variable = rdf_string_1.termToString(_aggregate.variable);

          _group.aggregators[variable].put(bindings);
        }
      }
    }
    /**
     * Collect the result of the current state. This returns a Bindings per group,
     * and a (possibly empty) Bindings in case the no Bindings have been consumed yet.
     */

  }, {
    key: "collectResults",
    value: function collectResults() {
      // Collect groups
      var rows = Array.from(this.groups, function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            _ = _ref3[0],
            group = _ref3[1];

        var groupBindings = group.bindings,
            aggregators = group.aggregators; // Collect aggregator bindings
        // If the aggregate errorred, the result will be undefined

        var aggBindings = {};

        for (var variable in aggregators) {
          var value = aggregators[variable].result();

          if (value !== undefined) {
            // Filter undefined
            aggBindings[variable] = value;
          }
        } // Merge grouping bindings and aggregator bindings


        return groupBindings.merge(aggBindings);
      }); // Case: No Input
      // Some aggregators still define an output on the empty input
      // Result is a single Bindings

      if (rows.length === 0) {
        var single = {};

        for (var i in this.pattern.aggregates) {
          var aggregate = this.pattern.aggregates[i];
          var key = rdf_string_1.termToString(aggregate.variable);
          var value = sparqlee_1.AggregateEvaluator.emptyValue(aggregate);

          if (value !== undefined) {
            single[key] = value;
          }
        }

        rows = [bus_query_operation_1.Bindings(single)];
      }

      return rows;
    }
    /**
     * @param {Bindings} bindings - Bindings to hash
     */

  }, {
    key: "hashBindings",
    value: function hashBindings(bindings) {
      return actor_abstract_bindings_hash_1.AbstractFilterHash.hash('sha1', 'hex', bindings);
    }
  }]);

  return GroupsState;
}();

exports.GroupsState = GroupsState;